import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space, width } from 'styled-system';

import Spinner from 'common/components/Spinner';
import { HeadlineH3 } from 'common/components/Typography';
import BrandsNav from './BrandsNav';
import BrandsSection from './BrandsSection';
import { useBrandsGlossary } from './hooks';
import type { BrandsGlossaryProps } from './types';

const Article = styled.article<any>`
  ${width};
  ${space};
`;

const articleStyles: ComponentProps<typeof Article> = {
  width: [1, 6 / 8, 8 / 12],
  mx: 'auto',
};

const headingStyles: ComponentProps<typeof HeadlineH3> = {
  as: 'h2',
  mt: 'sp_0',
  mb: ['sp_16', null, 'sp_24'],
  textAlign: 'center',
};

const BrandsGlossary = ({ glossaryHeading }: BrandsGlossaryProps) => {
  const [brandsSections, isLoading] = useBrandsGlossary();

  return (
    <Article {...articleStyles} data-corgi-id="brands-glossary">
      <HeadlineH3 {...headingStyles}>{glossaryHeading}</HeadlineH3>
      {isLoading && <Spinner strokeColor="sys.neutral.border.hover" />}
      {brandsSections && (
        <>
          <BrandsNav brandsSections={brandsSections} />
          {brandsSections.map(brandsSection => (
            <BrandsSection key={brandsSection.key} brandsSection={brandsSection} />
          ))}
        </>
      )}
    </Article>
  );
};

export default BrandsGlossary;
